<span class="rc-attribute rc-attribute--{{ attribute.type }}">
  @switch (attribute.type) {
    @case ([AttributeType.Link, AttributeType.FbLink].includes(attribute.type) ? attribute.type : '') {
      <a class="rc-attribute--link" [href]="href" target="_blank">
        {{ attrVal | async }}
      </a>
    }
    @case (AttributeType.Image) {
      <img [src]="val || attribute.default" class="rc-logo" alt="" />
    }
    @case (AttributeType.Species) {
      <span>
        {{ val | translationCode: LocaleContentEnum.Species }}
      </span>
    }
    @case (AttributeType.Lang) {
      <span>
        {{ 'language_' + val | translateKey }}
      </span>
    }
    @case (AttributeType.Gender) {
      <span>
        {{ val | translationCode: LocaleContentEnum.Gender }}
      </span>
    }
    @case (AttributeType.MeasurementSystem) {
      <span>
        {{ val | translationCode: LocaleContentEnum.MeasurementSystem }}
      </span>
    }
    @case (AttributeType.Breed) {
      <span>
        {{ val | breed | async }}
      </span>
    }
    @case (AttributeType.PetActivity) {
      <span>
        {{ val | translationCode: LocaleContentEnum.PetActivity }}
      </span>
    }
    @case (AttributeType.Weight) {
      <span>
        {{ val | weight: currentSystemPreferenceCode }}
      </span>
    }
    @case (AttributeType.WeightNumber) {
      <span>
        {{ { measure: val, measureUnit: weightUnit } | weight: currentSystemPreferenceCode }}
      </span>
    }
    @case (AttributeType.Date) {
      <span>
        {{ val | date: 'shortDate' }}
      </span>
    }
    @case (AttributeType.Neutered) {
      <span>
        {{ val | neutered }}
      </span>
    }
    @default {
      <span [appDataCSmask]="maskPii"> {{ attrVal | async }} </span>
    }
  }
</span>
